export default "__VITE_ASSET__Byuhugua__"